import { PropsWithChildren } from 'react'
import classNames from 'classnames'

type ToggleButtonProps = {
  selected?: boolean
  onClick?: () => void
} & PropsWithChildren

const ToggleButton = ({ children, selected = false, onClick }: ToggleButtonProps) => {
  return (
    <button
      className={classNames(
        'outline-none font-semibold transition-all rounded text-[12px] border px-[10px] py-[7px] w-full leading-[14px]',
        {
          'bg-gray-900 text-white border-gray-900 hover:bg-gray-700 focus-visible:ring-primary-200 active:ring-primary-200 disabled:bg-gray-700': selected,
          'bg-transparent border border-black-500 text-black-900 hover:bg-black-100 hover:border-black-100': !selected,
        },
      )}
      onClick={() => onClick?.()}
    >
      {children}
    </button>
  )
}

export default ToggleButton
